import * as React from "react";
import classnames from "classnames";
import { MediaQuery } from "@grandvisionhq/common";
import LocationSearchTabsContainer from "../../../LocationSearchTabs/components/LocationSearchTabs/LocationSearchTabsContainer.js";
/* empty css                    */
const LocationSearch = ({
  className,
  searchForm,
  listContent,
  listTopContent,
  mapContent,
  showTabs = false,
  scrollToHandlerId,
  ...rest
}) => {
  const isMobile = MediaQuery.useIsPhone();
  return /* @__PURE__ */ React.createElement("article", { ...rest, className: classnames("location-search", className) }, listTopContent, isMobile && /* @__PURE__ */ React.createElement("div", { id: scrollToHandlerId, className: "location-search__search-form" }, searchForm), /* @__PURE__ */ React.createElement("div", { className: "location-search__wrapper" }, /* @__PURE__ */ React.createElement(
    LocationSearchTabsContainer,
    {
      showTabs,
      listContent,
      mapContent
    }
  )));
};
export {
  LocationSearch as default
};
//# sourceMappingURL=LocationSearch.js.map
